<div class="address-container pt-3 pb-1" (appClickOutside)="clickOutside($event)">
    <div class="address-header mb-2">
        <h1>{{ patient.patientName }}</h1>
        <div class="d-flex align-items-center">
            @if (!editing && !patient.addressUpdating) {
                <app-tooltip
                    title="{{'EDIT_ADDRESS' | translate}}"
                    [compact]="true"
                    (click)="edit($event)"
                >
                    <ng-container icon>
                        <span
                            class="vismaicon vismaicon-sm vismaicon-edit"
                            [ngClass]="{
                                disabled: patient.taskUpdating || patient.feasibilityReloading
                            }"
                        ></span>
                    </ng-container>
                </app-tooltip>
            }
            @if (editing || patient.addressUpdating) {
                @if (!patient.addressUpdating) {
                    <ng-container [formGroup]="addressForm">
                        <div class="d-flex">
                            {{ 'PERMANENT' | translate }}
                            <app-toggle
                                id="patientAddressPermanent"
                                class="ml-2"
                                [formControl]="addressForm.controls['permanent']"
                            ></app-toggle>
                        </div>
                        <div class="d-flex">
                            <app-tooltip title="{{'REVERT' | translate}}" [compact]="true" (click)="reset()">
                                <ng-container icon>
                                    <span
                                        class="vismaicon vismaicon-sm vismaicon-refresh vismaicon-reverse mr-2"
                                        [ngClass]="{ disabled: addressForm.pristine }"
                                    ></span>
                                </ng-container>
                            </app-tooltip>
                            <app-tooltip
                                title="{{'SAVE' | translate}}"
                                [compact]="true"
                                (click)="saveAddress($event)"
                            >
                                <ng-container icon>
                                    <span
                                        class="vismaicon vismaicon-sm vismaicon-save"
                                        [ngClass]="{ disabled: saveDisabled() }"
                                    ></span>
                                </ng-container>
                            </app-tooltip>
                        </div>
                    </ng-container>
                }
                @if (patient.addressUpdating) {
                    <div class="spinner"></div>
                }
            }
        </div>
    </div>
    <form class="form-horizontal" [formGroup]="addressForm">
        <div class="form-group">
            <span class="col-xs-4 control-label">{{ 'CLIENT_ID' | translate }}</span>
            <span class="col-xs-8 control-label">
                {{ patient?.patientId }}
            </span>
        </div>
        <div class="form-group" [ngClass]="{ 'has-error': !addressValid && !validating }">
            <label class="col-xs-4 control-label d-flex" for="address-input">
                {{ 'ADDRESS' | translate }}
                <app-info-tooltip
                    class="ml-2"
                    appCustomPopover
                    popoverText="ADDRESS_VALIDATION_INFO"
                    placement="top"
                    iconSize="sm"
                ></app-info-tooltip>
            </label>
            <div class="col-xs-6">
                <app-form-input-autocomplete
                    id="address-input"
                    type="search"
                    class="w-100"
                    formControlName="address"
                    appCustomPopover
                    placement="right"
                    popoverType="error"
                    placeholder="{{ 'ADDRESS_SEARCH_PLACEHOLDER' | translate }}"
                    [popoverText]="addressValid || validating ? '' : 'ADDRESS_NOT_FOUND' | translate"
                    [errorVisual]="addressValid || validating ? '' : 'ADDRESS_NOT_FOUND' | translate"
                    [readonly]="!editing"
                    [searching]="validating"
                    (changed)="validateAddress()"
                    [addressSuggestions]=addressSuggestions
                >
                </app-form-input-autocomplete>
            </div>
        </div>
        <div class="form-group">
            <span class="col-xs-4 control-label">{{ 'ZIP_CODE' | translate }}</span>
            @if (!addressForm.value.zipCodeWarning) {
                <span class="col-xs-8 control-label" data-qa="qa-patient-zip">
                    {{ patient.zipCode }}
                </span>
            }
            @if (addressForm.value.zipCodeWarning) {
                <span class="col-xs-3 control-label">
                    {{ editing ? addressForm.value.zipCodeSuggestion : patient.zipCode }}
                    @if (!editing) {
                        <span>-> <b>{{ addressForm.value.zipCodeSuggestion }}</b></span>
                    }
                </span>
                @if (!editing) {
                    <div class="col-xs-3">
                        <app-button
                            label="APPROVE"
                            size="sm"
                            [loading]="patient.addressUpdating"
                            (click)="approveZipCode($event)"
                        ></app-button>
                    </div>
                    <div class="col-xs-2 d-flex">
                        <span class="vismaicon vismaicon-md vismaicon-filled vismaicon-warning"></span>
                    </div>
                }
            }
        </div>
        <div class="form-group">
            <label class="col-xs-4 control-label" for="addressDescription">{{ 'OTHER_INFO' | translate }}</label>
            <div class="col-xs-6">
                <input type="text" id="addressDescription" class="form-control" formControlName="addressDescription" [readonly]="!editing"/>
            </div>
        </div>
    </form>
</div>
